import { render, staticRenderFns } from "./mainFnBodySecend.vue?vue&type=template&id=466a827d&"
import script from "./mainFnBodySecend.vue?vue&type=script&lang=js&"
export * from "./mainFnBodySecend.vue?vue&type=script&lang=js&"
import style0 from "./mainFnBodySecend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import IRate from '@/components/IRate'
import ISelect from '@/components/ISelect'
component.options.components = Object.assign({IRate,ISelect}, component.options.components)
